import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPhoneAlt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

const Footer = ({ hasUserOnServicePage = false }) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const [selectedCategory, setSelectedCategory] = useState(
    localStorage.getItem("selectedCategory") || "products"
  );

  useEffect(() => {
    localStorage.setItem("selectedCategory", selectedCategory);
  }, [selectedCategory]);

  useEffect(() => {
    if (location.pathname.includes("/services")) {
      setSelectedCategory("services");
    } else if (location.pathname.includes("/products")) {
      setSelectedCategory("products");
    }
  }, [location.pathname]);

  const handleSellOnNearme = () => {
    const isAppInstalled = false;
    if (isAppInstalled) {
      window.location.href = "nearmeapp://sell";
    } else {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.raja.NearMe_Business&hl=en_IN";
    }
  };

  const handleServiceClick = () => {
    setSelectedCategory(hasUserOnServicePage ? "products" : "services");
  };

  return (
    <footer className="footer-container">
      <div className="footer-wave"></div>
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section footer-company-info">
            <h2 className="footer-company-name">
              <span className="footer-brand-highlight">Nearme</span> - Search
              Locally
            </h2>
            <p className="footer-company-description">
              Connecting local businesses with customers in your neighborhood.
            </p>
            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/share/1EYr8xY4nG/?mibextid=qi2Omg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              {/* <a href="#" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} />
              </a> */}
              <a
                href="https://www.instagram.com/nearmeind?igsh=ZDFyMzE2NWVjbzc1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://in.linkedin.com/in/near-me-7560a2305"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a
                href="https://youtube.com/@nearmeind?si=_5k2LL6p5EjpsPtj"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section footer-links-section">
            <h3 className="footer-section-title">Quick Links</h3>
            <ul className="footer-links-list">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/" onClick={handleServiceClick}>
                  {hasUserOnServicePage ? "Products" : "Services"}
                </Link>
              </li>
              {/* <li>
                <Link to="/contact">Contact</Link>
              </li> */}
            </ul>
          </div>

          {/* Make Money */}
          <div className="footer-section footer-make-money-section">
            <h3 className="footer-section-title">Make Money With Us</h3>
            <ul className="footer-links-list">
              <li>
                <button
                  onClick={handleSellOnNearme}
                  className="footer-link-button"
                >
                  Sell on Nearme
                </button>
              </li>
              {/* <li>
                <Link to="/business">Business Solutions</Link>
              </li>
              <li>
                <Link to="/advertise">Advertise With Us</Link>
              </li>
              <li>
                <Link to="/affiliate">Affiliate Program</Link>
              </li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section footer-contact-section">
            <h3 className="footer-section-title">Connect With Us</h3>
            <div className="footer-contact-info">
              <div className="footer-contact-item">
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="footer-contact-icon"
                />
                <span>
                  NearMe India, B2/1805 18th Floor, Panchsheel Greens 2, GH01A,
                  Sector 16, Greater Noida, U.P, India - 201306
                </span>
              </div>
              <div className="footer-contact-item">
                <FontAwesomeIcon
                  icon={faPhoneAlt}
                  className="footer-contact-icon"
                />
                <a href="tel:+918544104411">+91 85441-04411</a>
              </div>
              <div className="footer-contact-item">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="footer-contact-icon"
                />
                <a href="mailto:support@nearmeind.com">support@nearmeind.com</a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>
            &copy; {currentYear}{" "}
            <span className="footer-brand-highlight">NearMe</span> - Search
            Locally. All rights reserved.
          </p>
          <div className="footer-legal-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            {/* <Link to="/terms">Terms of Service</Link>
            <Link to="/cookies">Cookie Policy</Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
